// project imports
// action - state management
import moment from "moment";
import * as actionTypes from "../../actions/actionTypes";
import {
  getAllMonthsBetweenDates,
  getAllYearsBetweenDates,
} from "utils/formatter";

// TODO: Move it from here?
export const PRIMARY_COLOR_KEY = "primary";
export const SECONDARY_COLOR_KEY = "secondary";
export const TEXT_COLOR_KEY = "text";
export const SWITCH_COLOR_KEY = "switch";
export const HISTORICAL_COLOR_KEY = "historical";
export const PROJECTION_COLOR_KEY = "projection";

export const CORPORATE_TAX_KEY = "corporateTax";
export const VAT_KEY = "vat";
export const LONG_TERM_GROWTH_RATE_KEY = "longTermGrowthRate";
export const BEGINNING_CASH_KEY = "beginningCash";

// time series assumptions' keys
export const PRIMARY_PERIODICITY_KEY = "primaryPeriodicity";
export const FIRST_FINANCIAL_YEAR_KEY = "firstFinancialYear";
export const FINANCIAL_YEARS_KEY = "FinancialYears";
export const FINANCIAL_MONTHS_KEY = "financialMonths";
export const FINANCIAL_MONTHS_NEW_KEY = "financialMonthsNew";
export const CURRENCY_KEY = "currency";

// tab keys
export const ASSUMPTIONS_TAB_KEY = "assumptions";
export const SUBSCRIBER_ACQUISITION_TAB_KEY = "subscriberAcquisitions";
export const SUBSCRIPTION_REVENUE_TAB_KEY = "subscriptionRevenue";
export const COST_AND_EXPENSES_TAB_KEY = "costAndExpenses";
export const HIRING_PLAN_TAB_KEY = "hiringPlane";
export const PROFIT_AND_LOSS_TAB_KEY = "profitAndLoss";
export const FREE_CASH_FLOW_TAB_KEY = "freeCashFlow";
export const CUSTOMIZATION_TAB_KEY = "customization";
export const PERFORMANCE_TAB_KEY = "perforce";

export const initialState = {
  colors: {
    primary: "#27797E",
    secondary: "#0B7595",
    text: "#FFFFFF",
    switch: "#FCE4D6",
    historical: "#FFFAF1",
    projection: "#F2F2F2",
  },
  primaryColor: "#27797E",
  secondaryColor: "#0B7595",
  textColor: "white",
  open: {
    [ASSUMPTIONS_TAB_KEY]: {
      general: true,
      timeSeries: true,
      subscriberAcquisition: true,
      netWorkingCapital: true,
      capex: true,
      colorPalette: true,
    },
    [CUSTOMIZATION_TAB_KEY]: {
      colorPalette: true,
      assumptionDetails: true,
      fontFamily: true,
      borderRadius: true,
    },
    [SUBSCRIBER_ACQUISITION_TAB_KEY]: {
      keyAssumptions: true,
      newInstalls: true,
      cumulativeInstalls: true,
      cumulativeMembers: true,
      cumulativeSubscribers: true,
    },
    [SUBSCRIPTION_REVENUE_TAB_KEY]: {
      subscriptionRevenue: true,
      subscriptionCommissions: true,
      otherRevenue: true,
      unitSales: true,
      billableHours: true,
      recurringCharges: true,
      generalOtherRevenue: true,
    },
    [COST_AND_EXPENSES_TAB_KEY]: {
      costOfSales: true,
      generalAdministrativeExpenses: true,
      salesAndMarketingExpenses: true,
    },
    [HIRING_PLAN_TAB_KEY]: {
      foundersAndPartners: true,
      techAndProductDev: true,
      salesAndMarketing: true,
      financeAndAnalytics: true,
      other: true,
      average: true,
    },
    [PROFIT_AND_LOSS_TAB_KEY]: {
      main: true,
    },
    [FREE_CASH_FLOW_TAB_KEY]: {
      main: true,
    },
    [PERFORMANCE_TAB_KEY]: {
      totalRevenue: true,
      totalProfit: true,
      totalCost: true,
    },
  },
  companyName: "PLANSAS",
  generalAssumptions: {
    corporateTax: 20,
    vat: 18,
    longTermGrowthRate: 3,
    beginningCash: 10000,
  },
  timeSeriesAssumptions: {
    [PRIMARY_PERIODICITY_KEY]: "Yearly",
    [FIRST_FINANCIAL_YEAR_KEY]: 1,
    [FINANCIAL_YEARS_KEY]: {
      firstFinancialYear: moment().toDate(),
      lastFinancialYear: moment().add(4, "Y").toDate(),
      numberOfFinancialYears: 5,
      yearTitles: getAllYearsBetweenDates(
        moment().toDate(),
        moment().add(4, "Y").toDate()
      ),
    },
    [FINANCIAL_MONTHS_KEY]: 36,
    [FINANCIAL_MONTHS_NEW_KEY]: {
      monthCount: 36,
      startDate: moment().toDate(),
      endDate: moment().add(35, "M").toDate(),
      monthTitles: getAllMonthsBetweenDates(
        moment().toDate(),
        moment().add(35, "M").toDate()
      ),
    },
    [CURRENCY_KEY]: "USD",
  },
};

// ==============================|| FINANCIAL FORECAST REDUCER ||============================== //

const financialForecastReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COLOR:
      return {
        ...state,
        colors: {
          ...state.colors,
          [action.key]: action.color,
        },
      };
    case actionTypes.SET_OPEN:
      return {
        ...state,
        open: {
          ...state.open,
          [action.tabKey]: {
            ...state.open[action.tabKey],
            [action.key]: !state.open[action.tabKey][action.key],
          },
        },
      };
    case actionTypes.SET_OPEN_FLAG:
      return {
        ...state,
        open: {
          ...state.open,
          [action.tabKey]: {
            ...state.open[action.tabKey],
            [action.key]: action.payload,
          },
        },
      };
    // SET_OPEN_FLAG
    case actionTypes.SET_GENERAL_ASSUMPTION:
      return {
        ...state,
        generalAssumptions: {
          ...state.generalAssumptions,
          [action.key]: action.value,
        },
      };
    case actionTypes.SET_TIME_SERIES_ASSUMPTION:
      return {
        ...state,
        timeSeriesAssumptions: {
          ...state.timeSeriesAssumptions,
          [action.key]: action.value,
        },
      };
    case actionTypes.SET_COMPANY_NAME:
      return {
        ...state,
        companyName: action.companyName,
      };
    case actionTypes.RESET_COLORS:
      return {
        ...state,
        colors: action.colors,
      };
    case actionTypes.UPDATE_PRIMARY_PERIODICITY_KEY:
      return {
        ...state,
        timeSeriesAssumptions: {
          ...state.timeSeriesAssumptions,
          [PRIMARY_PERIODICITY_KEY]: action?.payload,
        },
      };
    default:
      return state;
  }
};

export default financialForecastReducer;
